import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BehaviorSubject, catchError, Observable, tap, throwError, finalize } from 'rxjs';
import { environment } from '../../environments/environment';
import { BaseService } from './base.service';
import { LoadingService } from './loading.service';
import { City } from '../models/domain/City';
import { PagedResponse } from '../models/general/PagedResponse';

@Injectable({
  providedIn: 'root'
})
export class CityService extends BaseService<City> {
  private readonly rowCountSubject: BehaviorSubject<number>;
  public readonly rowCount$: Observable<number>;
  private http: HttpClient;

  constructor(http: HttpClient, public override loadingService: LoadingService) {
    super(http, `${environment.apiUrl}/v1/city`, loadingService);
    this.http = http;
    this.rowCountSubject = new BehaviorSubject<number>(0);
    this.rowCount$ = this.rowCountSubject.asObservable();
  }

  public getCityByState(stateId: number): Observable<HttpResponse<PagedResponse<City>>> {
    return this.httpClient.get<PagedResponse<City>>(`${this.baseApiUrl}/${stateId}/cities`, { observe: "response" })
      .pipe(tap(response => {
      }),
        catchError(error => {
          return throwError(() => error); // Make sure to throw the error properly
        }),
        finalize(() => {
          this.loadingService.hideLoading();
        })
      );
    // return this.httpClient.get<PagedResponse<City>>(
    //   `${this.baseApiUrl}/${stateId}/cities`,
    //   { observe: 'response' }
    // );
  }
}